import { Badge } from '@aqarmap/aqarmap-ui';
import { Trans, useTranslation } from 'react-i18next';
import { formatNumber } from '~/lib';
import FeatureStats from '~/pages/FeatureListing/FeatureStats';
import {
  getFeatureAmount,
  getFeatureDuration,
  getFeatureFees,
} from '~/pages/FeatureListing/utils';
import { ListingFeatureType } from '~/types/featureListingTypes';

export default function FeatureCard({
  feature,
  isPayAsYouGo = false,
  onSelect,
}: {
  feature: ListingFeatureType;
  isPayAsYouGo?: boolean;
  onSelect: (feature: ListingFeatureType) => void;
}) {
  const { t } = useTranslation('app');
  const price = isPayAsYouGo
    ? getFeatureAmount(feature)
    : getFeatureFees(feature);

  return (
    <div
      className={`flex h-full w-full flex-col gap-2x rounded-[10px] border bg-white p-2x ${
        feature.recommended ? 'border-orange' : 'border-gray'
      }`}
    >
      <div className="flex w-full items-center justify-between gap-x">
        <p className="text-title-5 text-black">{feature.title}</p>
        {feature.recommended ? (
          <Badge
            text={t('featureBestValue')}
            className="rounded-[8px] bg-orange px-[10px] text-caption-2 text-gray__dark_2"
          />
        ) : null}
      </div>

      <FeatureStats stats={feature.stats} />

      <p className="border-t border-gray pt-2x text-center text-title-5">
        <Trans
          i18nKey={
            isPayAsYouGo ? 'featureAmountDuration' : 'featureCreditDuration'
          }
          t={t}
          values={{
            credit: formatNumber(price),
            days: getFeatureDuration(feature),
          }}
          components={{
            tag: <span className="text-gray__dark_2">placeholder</span>,
          }}
        />
      </p>

      <button
        type="button"
        onClick={() => onSelect(feature)}
        className="btn-primary btn-medium element-center mt-auto rounded-[26px] !text-title-5"
      >
        {t('featureWithType', { name: feature.title })}
      </button>
    </div>
  );
}
